import { DropDownFilter, DropDownFilterProps } from 'framework/list';
import { PositionDropdown } from 'domain/shared/employee';

const SpecializationFilter = (props: Omit<DropDownFilterProps, 'children'>) => {
  return (
    <DropDownFilter {...props}>
      <PositionDropdown {...props} />
    </DropDownFilter>
  );
};

export default SpecializationFilter;
